export * from '@primeuix/themes/material/blockui';
export { default } from '@primeuix/themes/material/blockui';
